import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsFiscalizedCheckbox.module.scss';

interface IProps {
	toggleIsFiscalized: () => void;
	isFiscalized: boolean;
	isDisabled: boolean;
}

export const IsFiscalizedCheckbox: React.FC<IProps> = React.memo(({ toggleIsFiscalized, isFiscalized, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="isFiscalized" data-test="IsFiscalizedCheckbox">
			<Checkbox onChange={toggleIsFiscalized} checked={isFiscalized} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="isFiscalizedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
